//#region src/http/headers.ts
const ALCHEMY_USE_INTEGRATION_HEADER = "x-alchemy-use-integration";
const ALCHEMY_USE_INTEGRATION_HEADER_VALUE = "true";
const USE_EXPERIMENTAL_DATA_SOURCE_HEADER = "x-use-experimental-data-source";
//#endregion
export { ALCHEMY_USE_INTEGRATION_HEADER, ALCHEMY_USE_INTEGRATION_HEADER_VALUE, USE_EXPERIMENTAL_DATA_SOURCE_HEADER };

//# sourceMappingURL=headers.js.map